export class FormValidation {
    /**
     * Remove loading button animation
     *
     * @param {jquery} $form
     */
    static removeLoadingButton($form) {
        $form.find('.js-loading').removeClass('js-loading');
        $form.find('button[type="submit"]').removeAttr('disabled');
    }

    /**
     * Check if user has agreed with GDPR data
     *
     * @param {jQuery}$form
     * @returns {boolean}
     */
    static customerAggreementValid($form) {
        return true;
    }
}